import React from "react";
import {
  MagnifyingGlass,
  ThreeDots,
  ProgressBar,
  Bars,
} from "react-loader-spinner";
import Backdrop from "@mui/material/Backdrop";
import { useTheme, Theme } from "@mui/material/styles";
import { Box } from "@mui/material"; // Use Box instead of Grid since Grid is deprecated

// Define the props interface
interface LoadingProps {
  loading: boolean;
  type: "glass" | "dots" | "progress" | "bars";
  backDrop?: boolean;
}

const Loading: React.FC<LoadingProps> = (props) => {
  const theme: Theme = useTheme();

  const getPropTypeLoading = () => {
    switch (props.type) {
      case "glass":
        return (
          <MagnifyingGlass
            visible={props.loading}
            height="80"
            width="80"
            ariaLabel="MagnifyingGlass-loading"
            wrapperStyle={{}}
            wrapperClass="MagnifyingGlass-wrapper"
            glassColor="#c0efff"
            color="#e15b64"
          />
        );
      case "dots":
        return (
          <ThreeDots
            height="80"
            width="80"
            color={theme.palette.primary.light}
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            visible={props.loading}
          />
        );
      case "progress":
        return (
          <ProgressBar
            height="80"
            ariaLabel="progress-bar-loading"
            wrapperStyle={{}}
            wrapperClass="progress-bar-wrapper"
            borderColor="#F4442E"
            barColor={theme.palette.primary.light}
            visible={props.loading}
          />
        );
      default:
        return (
          <Bars
            height="80"
            width="80"
            color={theme.palette.primary.light}
            ariaLabel="bars-loading"
            wrapperStyle={{}}
            visible={props.loading}
          />
        );
    }
  };

  const allowBackDrop = () => {
    if (props.backDrop) {
      return (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
            position: "absolute",
          }}
          open={props.loading}
        >
          {getPropTypeLoading()}
        </Backdrop>
      );
    }
    return getPropTypeLoading();
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      width="100%"
      height="100%"
    >
      {props.loading && allowBackDrop()}
    </Box>
  );
};

export default Loading;
